<template>
    <div>

        <v-toolbar app color="black" dark>
            <v-toolbar-title data-cy="titleBtn">
                <img class="menuLogo ml-0" src="../assets/images/logo_icron_2.0_bianco.png" style="height: 45px"
                    @click="gotoHome()" />
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-layout v-if="isDesktopMode()" align-start row justify-center class="red darken-2 p-0 m-0"
                style="border-radius: 10px 10px 10px 10px"><span class="white--text"><strong>{{ raceInfo.name }}</strong> |
                    Live
                    results
                </span>
            </v-layout>
            <v-spacer></v-spacer>
            <v-icon class="mr-4" @click="filterToggle = !filterToggle">search</v-icon>
            <!--v-icon
                v-if="filterPreferiti"
                class="mr-4 yellow--text"
                @click="togglePreferiti()"
                >star</v-icon
            >
            <v-icon v-else class="mr-4 yellow--text" @click="togglePreferiti()"
                >star_border</v-icon
            -->
            <span v-if="isMobileMode()">
                <v-icon v-if="!compatta" @click="compatta = !compatta">compress</v-icon>
                <v-icon v-else @click="compatta = !compatta">expand</v-icon>
            </span>
        </v-toolbar>




        <v-layout  align-start row wrap justify-center
            class="pa-2 black--text grey lighten-4 ">


            <v-flex flex xs12 sm12 md12 lg12 class="blue darken-2 white--text title mt-4 font-weight-black pa-2">
                {{ report.description }}
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12 class="black--text title mt-3 ">

                <v-data-table :items="itemsF" hide-actions style="" class="mb-5">
                    <template slot="headers" slot-scope="props">
                        <tr class="" style="background-color: #f5f5f5 !important; height:20px">
                            <th v-if="isFiltered()" nowrap align="center">
                                N.
                            </th>
                            <th v-for="split in  report.fields" :key="split.id" no-wrap>{{ split.name
                            }}<span class="mr-2"><v-icon class="ml-2" @click="orderBySplit(split)"
                                        small>swap_vert</v-icon><v-icon class="ml-1" color="grey"
                                        @click="filterByField(split)" small>filter_list</v-icon></span>
                            </th>
                        </tr>
                    </template>
                    <template slot="items" slot-scope="props" class="scroll-y" style="height: 600px">
                        <tr style="height:0px">
                        </tr>
                        <tr style="height:30px" v-if="props.item.raggr == true" class="pa-2">
                            <td :colspan="report.fields.length + 1" class="title pa-1">&nbsp;</td>
                        </tr>
                        <tr style="height:20px; " v-if="props.item.raggr == true"
                            class="ma-2 pa-2 black white--text font-weight-black">
                            <td :colspan="report.fields.length + 1" class="title pa-1"
                                style=" border-radius: 5px 5px 0px 0px;"><strong>{{ formatCell(getValue(groupMap,
                                    props.item), groupMap) }}</strong></td>
                        </tr>
                        <tr style="height:20px" :class="line_classes(props.item.participant.cognome)">
                            <td v-if="isFiltered()" nowrap align="center" class="pa-1 black white--text">
                                <span>{{ props.index + 1 }}</span>
                            </td>
                            <td @click="selectParticipant(props.item)" nowrap :align="getAlign(split.align)"
                                v-for="split in  report.fields" :key="split.id + '' + props.item.pett"
                                :class="'pa-1  ' + getCellColor(split, props.item)">
                                <span>{{ formatCell(getValue(split, props.item), split) }} </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>




        </v-layout>

    </div>
</template>


<script>


export default {
    components: {
    },
    name: 'LiveView',

    data() {
        return {

            myInterval: undefined,
            showAddTimingSourceDialog: false,
            name: '',
            sync: '00:00:00.000',

            tpSelected: undefined,

            timingPoint: undefined,

            items: [],
            itemsF: [],

            fields: [],

            filterKey: undefined,
            filterValue: undefined,
            searchText: '',
            direction: true,
            orderByField: null,

            coloriSplit: {},

            showColumn: 'frazioni',
            showColors: false,

            selectedResult: undefined,

            filtroSesso: 'GENERALE',

            busyChannel: false,

            cacheKey: "null",

            raceInfo: {},

            report: {},

            filterMap: {}

        };
    },

    mounted() {
        this.reportId = this.$route.params.reportId;

        clearInterval(this.myInterval);
        this.myInterval = setInterval(this.refresh, 3000, this);

        //this.listaFields = this.report.fields.sort((a, b) => a.position - b.position)

        // this.raceInfo = this.getRaceConfig('raceInfo', true)

        this.loadReport()
    },


    beforeDestroy() {
        clearInterval(this.myInterval);
    },

    methods: {

        refresh: function (self) {
            self.loadReport();
        },


        loadReport(force = false) {

            if (!force && this.busyChannel) {
                console.log("busy")
                return;
            }

            this.busyChannel = true;
            const _url = this.getDataURL() + "getFile?idGara=icronium&fileName=" + this.reportId + ".json";;
            this.getCall(_url).then((response) => {
                this.items = response.items;
                this.report = response.report;
                this.raceInfo = response.raceInfo

                this.fields = this.report.fields.sort((a, b) => {
                    return a.position - b.position;
                })

                this.filterMap = JSON.parse(this.report.filterBy)
                console.log(this.filterBy)


                this.itemsF = this.filteredList();

                this.busyChannel = false;


            });
        },



        getValue(split, result, isCompare = false) {
            if (split.fieldSource == 'ANAGRAFICA') {
                if (split.type != undefined && split.type.indexOf(".") != -1) {
                    let fieldTok = split.type.split(".")
                    if (fieldTok[1] == 'atleta') {
                        return result[fieldTok[0]]['cognome'] + ' ' + result[fieldTok[0]]['nome']
                    }
                    return result[fieldTok[0]][fieldTok[1]]
                }
                const r = result[split.type];
                if (r == 999999 && !isCompare && (split.type == 'posizione' || split.type == 'posizioneCategoria' || split.type == 'posizioneMF')) return "DNS"
                if (r == 999998 && !isCompare && (split.type == 'posizione' || split.type == 'posizioneCategoria' || split.type == 'posizioneMF')) return "DNF"
                if (r == 999997 && !isCompare && (split.type == 'posizione' || split.type == 'posizioneCategoria' || split.type == 'posizioneMF')) return "DSQ"

                return r
            } else {
                let field = result.mappaFields[split.fieldSource];

                if (!!field) {
                    if (split.type == 'Tempo Frazione') return field.passaggio;
                    else if (split.type == 'Tempo Passaggio') return field.tempo;
                    else if (split.type == 'Orario Passaggio') return field.orario;
                    else if (split.type == 'Posizione Frazione') return field.posizioneFrazione
                    else if (split.type == 'Posizione Passaggio') return field.posizioneDivisione
                    else if (split.type == 'Media Frazione') return field.mediaFrazione
                    else if (split.type == 'Media Passaggio') return field.mediaPassaggio
                }
                return "-";

            }
        },

        formatValue(value, split) {
            if (split.type !== undefined && split.type !== null && split.type.toUpperCase().indexOf("TEMPO") !== -1 && value != '-' && value != undefined) {
                return this.formatTimestamp(value, split.format);
            }
            if (value == undefined) return "";
            return value;
        },

        formatCell(value, split) {

            if (split.format != undefined && split.format != null && split.format != '') {
                return this.formatValue(value, split)
            }


            if (split.type == 'tempo' || split.type == 'orario') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'Tempo Frazione') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'Tempo Passaggio') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'Orario Passaggio') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'min') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'max') return this.formatTime(value, this.raceInfo.sport)
            //else if (split.type == 'Posizione Frazione') return field.posizioneFrazione
            //else if (split.type == 'Posizione Passaggio') return field.posizioneDivisione
            //else if (split.type == 'Media Frazione') return field.mediaPassaggio


            return value;
        },

        formatCellPrint(value, split) {

            if (split.format != undefined && split.format != null && split.format != '') {
                return this.formatValue(value, split)
            }

            if (split.type == 'tempo' || split.type == 'orario') return '<strong>' + this.formatTime(value, this.raceInfo.sport) + '</strong>'
            else if (split.type == 'Tempo Frazione') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'Tempo Passaggio') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'Orario Passaggio') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'min') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'max') return this.formatTime(value, this.raceInfo.sport)

            else if (split.type == 'participant.cognome') return '<strong>' + value + '</strong>'
            else if (split.type == 'participant.nome') return '<strong>' + value + '</strong>'
            //else if (split.type == 'Posizione Frazione') return field.posizioneFrazione
            //else if (split.type == 'Posizione Passaggio') return field.posizioneDivisione
            //else if (split.type == 'Media Frazione') return field.mediaPassaggio


            return value;
        },

        formatCellDownload(value, split) {

            if (split.format != undefined && split.format != null && split.format != '') {
                return this.formatValue(value, split)
            }


            if (split.type == 'tempo' || split.type == 'orario') return this.formatTimeDownload(value, this.raceInfo.sport)
            else if (split.type == 'Tempo Frazione') return this.formatTimeDownload(value, this.raceInfo.sport)
            else if (split.type == 'Tempo Passaggio') return this.formatTimeDownload(value, this.raceInfo.sport)
            else if (split.type == 'Orario Passaggio') return this.formatTimeDownload(value, this.raceInfo.sport)
            else if (split.type == 'min') return this.formatTimeDownload(value, this.raceInfo.sport)
            else if (split.type == 'max') return this.formatTimeDownload(value, this.raceInfo.sport)
            return value;
        },


        formatTimeDownload(value, sport) {
            if (value != undefined && sport == 'Running' && value.indexOf(".") != -1) {
                let valueTok = value.split(".")
                return (valueTok[0])
            }
            return (value);
        },

        formatTime(value, sport) {
            if (value != undefined && sport == 'Running' && value.indexOf(".") != -1) {
                let valueTok = value.split(".")
                return this.riduci(valueTok[0])
            }
            return this.riduci(value);
        },

        getAlign(value) {
            if (value == "Sinistra") return "left"
            else if (value == "Destra") return "right"
            else if (value == "Centro") return "center"

            return value
        },

        getCellColor(split, item) {

            const value = this.getValue(split, item)

            if (value == 'DNF') return "orange lighten-2 black--text font-weight-black "
            else if (value == 'DNS') return "grey lighten-2 black--text font-weight-black "
            else if (value == 'DSQ') return "red white--text font-weight-black "

            const field = item.mappaFields[split.fieldSource];

            let addStyle = " ";
            if (split.color == 'green' || split.color == 'blue') addStyle = " white--text font-weight-black "

            if (!!field && field.note == 'MIN') return "green lighten-4 black--text font-weight-black "
            else if (!!field && field.note == 'MAX') return "orange lighten-2 black--text font-weight-black "
            else if (!!field && field.note == 'ALERT') return "red white--text font-weight-black "
            else if (value == "-") return "red";
            return split.color + addStyle
        },

        closeDetail() {
            this.selectedResult = undefined;
        },

        line_classes(name) {
            if (name == 'SCONOSCIUTO') return " red darken-2  "
            let color = this.coloriSplit[name]
            if (color != undefined) return color + " lighten-3";
            return ""
        },

        filteredList() {
            var listaSearch = this.items;
            if (this.searchText !== '' && this.searchText != null) {
                listaSearch = this.items.filter((p) => {
                    let res =
                        p != null &&
                        p.cognome != null &&
                        p.cognome.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;
                    let res1 =
                        p != null &&
                        p.squadra != null &&
                        p.squadra.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    let res2 =
                        p != null &&
                        p.pett != null &&
                        p.pett == this.searchText;

                    let resTot = res || res1 || res2;
                    return resTot;
                });
            }

            console.log("Applica filtro")

          
            if (this.filterList().length > 0) {
                console.log("Applica filtro")
                this.filterList().forEach(flkey => {

                    let listaTotKey = [];
                    let flValues = this.filterMap[flkey];
                    flValues.split(',').forEach(flVal => {
                        let _listaSearch = listaSearch.filter((p) => {
                            if (flkey.indexOf(".") != -1) {
                                let filtroTok = flkey.split(".")
                                return p[filtroTok[0]][filtroTok[1]] == flVal
                            }
                            return p[flkey] == flVal
                        });
                        listaTotKey.push(..._listaSearch);
                    })
                    listaSearch = listaTotKey;
                });
            }


            if (this.orderByField !== null) {
                listaSearch.sort(this.simpleCompare);
            }
            return listaSearch;
        },

        filterList() {
            if (this.filterMap == null ||  this.filterMap == undefined) return 0;

            return Object.keys(this.filterMap).sort()
        },

        changeSesso(sex) {
            this.filtroSesso = sex;
            let _sex = "";
            if (sex == 'MASCHILE') _sex = 'M';
            else if (sex == 'FEMMINILE') _sex = 'F';

            if (sex == 'GENERALE') {
                this.filterBy(undefined, undefined)
            } else {
                this.filterBy("participant.sesso", _sex)
            }

        },

        filterBy(key, value) {
            this.filterKey = key;
            this.filterValue = value;
            this.itemsF = this.filteredList()
        },

        orderBy(field) {
            if (this.orderByField === field) {
                this.direction = !this.direction;
            } else {
                this.direction = true;
                this.orderByField = field;
            }
            this.itemsF = this.filteredList();
        },

        orderBySplit(split) {
            //            console.log("Order by split " + split.name)
            //            console.log(split)

            if (split.fieldSource == 'ANAGRAFICA') {
                this.orderBy(split.type);
            } else {
                if (this.orderByField === split) {
                    this.direction = !this.direction;
                } else {
                    this.direction = true;
                    this.orderByField = split;
                }
                this.itemsF = this.filteredSplit();

            }
        },

        filteredSplit() {
            var listaSearch = this.items;
            listaSearch.sort(this.splitCompare);
            return listaSearch;
        },

        splitCompare(a, b) {
            return this.compareSplit(a, b)
        },

        compareSplit(a, b,) {
            const molti = this.direction ? 1 : -1;

            let valoreA = this.getValue(this.orderByField, a);
            let valoreB = this.getValue(this.orderByField, b);

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (!isNaN(valoreA) && !isNaN(valoreB)) {
                valoreA = parseFloat(valoreA);
                valoreB = parseFloat(valoreB);
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },


        simpleCompare(a, b) {
            return this.compareField(a, b)
        },

        compareField(a, b, fieldName = null) {

            if (fieldName == null) fieldName = this.orderByField;
            if (fieldName == 'participant.atleta') fieldName = 'participant.cognome';

            const molti = this.direction ? 1 : -1;

            let valoreA = a[fieldName];
            let valoreB = b[fieldName];

            let filtroTok = fieldName.split(".")
            if (filtroTok.length == 2) {
                valoreA = a[filtroTok[0]][filtroTok[1]];
                valoreB = b[filtroTok[0]][filtroTok[1]];
            }


            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (!isNaN(valoreA) && !isNaN(valoreB)) {
                valoreA = parseFloat(valoreA);
                valoreB = parseFloat(valoreB);
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },


        gotoAtleta(bib) {

        },


        selectParticipant(item) {
            //console.log("Selezionato:" + JSON.stringify(item))
            this.selectedResult = item;
            /*  const _url = this.getApiURL() + "passingByBib/" + this.selectedParticipant.pettorale;
              this.getCall(_url).then((response) => {
                  this.chipReadsAtleta = response;
                  //this.tabName = 'partecipanti'
                  this.tabAtleta('generale')
              });*/

        },

        download() {

            let divisione = this.report.criterio;
            let sesso = this.filtroSesso;



            const myArray = this.itemsF.filter(elem => {
                return true;
            });
            var result = "";

            this.report.fields.forEach(elem => {
                result += elem.name + ";"
            })

            result += "\n";
            for (var i = 0; i < myArray.length; i++) {
                result += "";
                this.report.fields.forEach(split => {
                    result += this.formatCellDownload(this.getValue(split, myArray[i]), split) + ";";
                })
                result += "\n";
            }


            //console.log(result)
            result = "data:text/csv;charset=utf-8," + result;

            var encodedUri = encodeURI(result);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "classifica_" + this.raceTitle + "_" + divisione + "_" + sesso + ".csv");
            document.body.appendChild(link); // Required for FF

            link.click();

            /* 
             */
        },



        catCompare(a, b, fieldName = 'participant.cat') {

            let res = this.sexCompare(a, b);
            if (res != 0) return res;

            let molti = 1;

            let valoreA = a[fieldName];
            let valoreB = b[fieldName];

            let filtroTok = fieldName.split(".")
            if (filtroTok.length == 2) {
                valoreA = a[filtroTok[0]][filtroTok[1]];
                valoreB = b[filtroTok[0]][filtroTok[1]];
            }

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },


        sexCompare(a, b, fieldName = 'participant.sesso') {
            let molti = 1;
            let filtroTok = fieldName.split(".")

            let valoreA = a[filtroTok[0]][filtroTok[1]];
            let valoreB = b[filtroTok[0]][filtroTok[1]];

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },



        isFiltered() {
            // if (this.report.orderBy != undefined && this.report.orderBy != '') return true;
            // if (this.report.filterBy != undefined && this.report.filterBy != '') return true;
            return false;
        },

        isGrouped() {
            // if (this.report.orderBy != undefined && this.report.orderBy != '') return true;
            if (this.report.groupBy != undefined && this.report.groupBy != '') return true;
            return false;
        },


    }
}
</script>
<style scoped>
td {
    height: 15px !important;
}
</style>
